/** Демо-данные для превью в админке — как в Telegram */
export const PREVIEW_CARD_DEMO = {
  cardNumber: '100001',
  name: 'Иван',
  surname: 'Иванов',
  balance: 100,
};
